import { useState } from 'react';
import { FileCheck, Mail, MessageCircle, ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = [
  {
    q: "Come funzionano i crediti?",
    a: "Ogni verifica di una busta paga utilizza 1 credito. Il primo controllo è gratuito. Puoi acquistare pacchetti di crediti dall'app tramite acquisto in-app."
  },
  {
    q: "Come verifico la mia busta paga?",
    a: "Vai nella sezione 'Verifica', inserisci i dati della tua busta paga (lordo, netto, IRPEF, INPS) oppure carica il PDF, e l'app calcolerà automaticamente se i valori sono corretti."
  },
  {
    q: "I miei dati sono al sicuro?",
    a: "Sì. Tutti i tuoi dati sono protetti con crittografia. Non vendiamo né condividiamo i tuoi dati con terze parti."
  },
  {
    q: "Posso ripristinare i miei acquisti?",
    a: "Sì. Nella sezione Crediti, scorri verso il basso e trovi il pulsante 'Ripristina acquisti precedenti'. Questo recupera tutti gli acquisti effettuati con il tuo account App Store."
  },
  {
    q: "L'app funziona senza internet?",
    a: "Per verificare le buste paga è necessaria una connessione internet. I dati già verificati sono visibili anche offline."
  },
  {
    q: "Come posso cancellare il mio account?",
    a: "Puoi richiedere la cancellazione del tuo account inviando una email a supporto@bustacontrollo.com con oggetto 'Cancellazione account'."
  },
];

export default function SupportPage() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-slate-200">
        <div className="container mx-auto px-4 md:px-8">
          <div className="flex items-center h-16">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-forest rounded-sm flex items-center justify-center">
                <FileCheck className="w-5 h-5 text-white" strokeWidth={1.5} />
              </div>
              <span className="font-bold text-lg tracking-tight text-forest">BustaControllo</span>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 md:px-8 py-12 max-w-3xl">
        {/* Title */}
        <div className="mb-10">
          <h1 className="text-4xl font-bold tracking-tight mb-3">Centro Assistenza</h1>
          <p className="text-lg text-muted-foreground">
            Trova le risposte alle domande più frequenti o contattaci direttamente.
          </p>
        </div>

        {/* Contact */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <a
            href="mailto:supporto@bustacontrollo.com"
            className="flex items-center gap-4 p-6 border border-slate-200 rounded-lg hover:border-forest transition-colors"
          >
            <div className="w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center flex-shrink-0">
              <Mail className="w-6 h-6 text-forest" />
            </div>
            <div>
              <h3 className="font-semibold mb-1">Email</h3>
              <p className="text-sm text-muted-foreground">supporto@bustacontrollo.com</p>
              <p className="text-xs text-muted-foreground mt-1">Risposta entro 24 ore</p>
            </div>
          </a>

          <a
            href="https://bustacontrollo.com"
            className="flex items-center gap-4 p-6 border border-slate-200 rounded-lg hover:border-forest transition-colors"
          >
            <div className="w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center flex-shrink-0">
              <MessageCircle className="w-6 h-6 text-forest" />
            </div>
            <div>
              <h3 className="font-semibold mb-1">Sito Web</h3>
              <p className="text-sm text-muted-foreground">bustacontrollo.com</p>
              <p className="text-xs text-muted-foreground mt-1">Informazioni e aggiornamenti</p>
            </div>
          </a>
        </div>

        {/* FAQ */}
        <div>
          <h2 className="text-2xl font-bold mb-6">Domande Frequenti</h2>
          <div className="space-y-3">
            {FAQ.map((item, idx) => (
              <div key={idx} className="border border-slate-200 rounded-lg overflow-hidden">
                <button
                  className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-colors"
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                >
                  <span className="font-medium">{item.q}</span>
                  {openFaq === idx
                    ? <ChevronUp className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                    : <ChevronDown className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                  }
                </button>
                {openFaq === idx && (
                  <div className="px-5 pb-5 text-muted-foreground text-sm leading-relaxed border-t border-slate-100">
                    <p className="pt-4">{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Privacy */}
        <div className="mt-12 pt-8 border-t border-slate-200 text-sm text-muted-foreground">
          <p>
            BustaControllo è sviluppato da <strong>Ikonet Solutions</strong>.{' '}
            <a href="https://ikonetsolutions.com/privacy-policy" className="text-forest hover:underline">
              Privacy Policy
            </a>
            {' · '}
            <a href="mailto:supporto@bustacontrollo.com" className="text-forest hover:underline">
              Contattaci
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
